module.exports = __webpack_public_path__ + "img/sir-john-herschel.366deadd.png";